module.exports = __webpack_public_path__ + "img/DimAllTheLIghts.af04106a.jpg";